import { Clock, Camera, Flag, IndianRupee } from "lucide-react";
import { Reveal, MaskedLinesInView } from "@/components/landing/Reveal";

const cards = [
  { icon: Clock, title: "Hours of Planning", body: "Spending weeks scrolling through conflicting online blogs after long work shifts." },
  { icon: Camera, title: "The Photos Lie", body: "Arriving to find the \"luxury resort\" is a noisy, poorly managed concrete block." },
  { icon: Flag, title: "Checklist Racing", body: "Drivers rushing your family through 15 crowded spots a day just to tick off a list." },
  { icon: IndianRupee, title: "Hidden Expenses", body: "Surprise entry fees, commercial food traps, and sudden upgrade costs." },
];

export const Problem = () => (
  <section className="bg-paper px-7 py-24 sm:px-12 lg:px-20 lg:py-32" data-testid="problem-section">
    <div className="mx-auto max-w-6xl">
      <Reveal>
        <p className="eyebrow text-gold mb-5">The Vacation Exhaustion Paradox</p>
      </Reveal>
      <h2 className="font-display text-4xl leading-tight text-ink sm:text-5xl lg:text-6xl max-w-3xl">
        <MaskedLinesInView lines={["\u201CWhy do I need a holiday", "to recover from my holiday?\u201D"]} />
      </h2>

      <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden border border-black/10 bg-black/10 sm:grid-cols-2 lg:grid-cols-4">
        {cards.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.08} className="h-full">
            <div className="group flex h-full flex-col bg-white p-8 transition-colors duration-300 hover:bg-[#FDFBF6]" data-testid={`pain-card-${i}`}>
              <span className="font-display text-sm text-black/20">0{i + 1}</span>
              <c.icon className="mt-8 h-7 w-7 text-gold" strokeWidth={1.5} />
              <h3 className="mt-6 font-display text-xl text-ink">{c.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-black/55">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
